if (!customElements.get('media-gallery')) {
    customElements.define(
        'media-gallery',
        class MediaGallery extends HTMLElement {
            constructor() {
                super();

                const mainEl = this.querySelector('.slideMain');
                const thumbEl = this.querySelector('.slideChild');
                const slideDesktop = parseInt(mainEl.dataset.slides) || 1;
                if (!mainEl || !thumbEl || !window.Swiper) return;

                this.thumbSwiper = new Swiper(thumbEl, {
                    spaceBetween: 5,
                    slidesPerView: 8,
                    freeMode: true,
                    watchSlidesProgress: true,
                    observer: true,
                    observeParents: true,
                });
                this.mainSwiper = new Swiper(mainEl, {
                    spaceBetween: 5,
                    slidesPerView: slideDesktop,
                    "autoHeight": true,
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next-product'),
                        prevEl: this.querySelector('.swiper-button-prev-product'),
                    },
                    thumbs: {
                        swiper: this.thumbSwiper,
                    },
                    observer: true,
                    observeParents: true,
                });

                // Slides hidden by the swiper's overflow never start lazy-loading until swiped in,
                // so fetch the neighbours of the active slide ahead of time.
                const loadAdjacentSlides = () => {
                    const { slides, activeIndex } = this.mainSwiper;
                    [activeIndex - 1, activeIndex + 1].forEach((i) => {
                        slides[i]?.querySelectorAll('img[loading="lazy"]').forEach((img) => {
                            img.loading = 'eager';
                        });
                    });
                };
                this.mainSwiper.on('slideChange', loadAdjacentSlides);
                loadAdjacentSlides();

                const variantId = new URLSearchParams(window.location.search).get('variant');

                if (variantId && window.productVariants) {
                    const variant = window.productVariants.find(
                        v => String(v.id) === variantId
                    );

                    if (variant && variant.featured_media) {
                        setTimeout(() => {
                            this.setActiveMedia(variant.featured_media.id);
                        }, 100);
                    }
                }
                document.addEventListener('variant:change', (event) => {
                    const variant = event.detail.variant;

                    if (variant && variant.featured_media) {
                        this.setActiveMedia(variant.featured_media.id);
                    }
                });
            }

            setActiveMedia(mediaId) {
                if (!this.mainSwiper) return;

                const slides = Array.from(
                    this.mainSwiper.slides
                );

                const index = slides.findIndex(
                    (slide) => String(slide.dataset.mediaId) === String(mediaId)
                );

                if (index === -1) return;

                this.mainSwiper.slideTo(index, 300);
            }
        }
    );
}
